export default {
  titulo: {
    salones: "Aulas",
    salon: "Aula",
    salonArticulo: "El Aula",
    salonesArticulo: "Las Aulas",

    cursos: "Asignaturas",
    curso: "Asignatura",
    cursoArticulo: "La Asignatura",
    cursosArticulo: "Las Asignaturas",

    seccion: "Sección",
    sesionAprendizaje: "Plan de Clase",
    sesionesAprendizajes: "Planes de Clases",
    sesionAprendizajeArticulo: "El Plan de Clase",
    sesionesAprendizajesArticulo: "Los Planes de Clases",

    director: "Rector",
    directores: "Rectores",
    directorArticulo: "El Rector",
    directoresArticulo: "Los Rectores",

    colegio: "Unidad Educativa",
    colegios: "Unidades Educativas",
    colegioArticulo: "La Unidad Educativa",
    colegiosArticulo: "Las Unidades Educativas",

    progDocente: "Planificación de Clase",
    progDocentes: "Planificaciones de Clases",
    progDocenteArticulo: "La Planificación de Clase",
    progDocentesArticulo: " Las Planificaciones de Clases",

    codigoNivelGrado: "Codigo Modular Ecuatoriano",
    codigoArea: "Codificación Ecuador",
  },

  ubicacion: {
    pais: "País",
    ubicacion1: "Provincia",
    ubicacion2: "Cantón",
    ubicacion3: "Parroquia",
  },

  modulos: {
    3: "Inicio",
    4: "Manager",
    5: "Configuración del Sistema",
    6: "Administración de Unidad Educativa",
    7: "Académico",
    8: "Evaluación",
    9: "Recursos Digitales",
    10: "Reportes",
    11: "Tesorería",
  },

  subModulos: {
    1: "Gestión de colegios",
    2: "Gestión de licencias",
    3: "Gestión de usuarios",
    4: "Gestión de niveles y grados",
    5: "Gestión de áreas",
    6: "Mi unidad educativa",
    12: "Año lectivo y periodos",
    13: "Niveles y grados",
    14: "Carpeta del estudiante",
    15: "Áreas",
    16: "Asignaturas",
    17: "Registro de alumno - familiar",
    19: "Registro de Personal",
    20: "Perfil webmaster",
    22: "Gestión de contenidos",
    26: "Programación docente",
    27: "Simuladores interactivos",
    28: "Plan lector",
    29: "Recursos multimedia",
    30: "Curso de inglés",
    31: "Gestión de evaluación",
    32: "Gestión de cursos",
    35: "Gestión de niveles y grados ",
    36: "Gestión de áreas",
    37: "Gestión de asignaturas",
    38: "Aula",
    39: "Asignación de asignaturas",
    40: "Asignación temario",
    41: "Admisión",
    42: "Matrícula",
    43: "Gestión de alumnos",
    44: "Grupos personalizados",
    45: "Configuración de gestión evaluativa",
    46: "Contenidos Clicken1",
    47: "Cuadernos de trabajo",
    48: "Estandares y competencias",
    49: "Derechos básicos",
    50: "Anecdótico docente",
    51: "Diagnostico de admisión",
    52: "Diagnostico progesivo",
    53: "Diagnostico docente",
    54: "Videos Clicken1",
    55: "Comunicados",
    56: "Aula virtual",
    57: "Enlaces de interes",
    58: "Buscadores de contenidos",
    59: "Capacitación Clicken1",
    61: "Permisos de usuarios",
    62: "Gestión de usuarios",
    63: "Mis clases",
    64: "Gestión de contenidos",
    65: "Permisos administrativos",
    66: "Coordinaciones",
    67: "Gestión docente",
    68: "Gestión clases de alumnos",
    69: "Gestión de clases dirección",
    70: "Gestión actividades de alumnos",
    71: "Gestión tareas dirección",
    72: "Gestión de dirección",
    73: "Enfoques transversales",
    74: "Competencias, capacidades y desempeños",
    75: "Mis actividades",
    76: "Mallla curricular",
    77: "Competencias",
    78: "Clases alumno",
    79: "Actividades alumnos",
    80: "Registro anecdótico",
    81: "Registro anecdótico coordinandor",
    82: "Planificacíon de clases",
    83: "Gestión de áreas",
    84: "Gestión de asignaturas",
    85: "Gestión de niveles y grados",
    86: "Configuración de Escala Evaluativa",
    87: "Libro Total – Biblioteca latinoamericana y universal",
    88: "Google Maps",

    89: "Competencias, capacidades y desempeños",
    90: "Formato reportes",
    91: "Configuración de manual  de convivencia",
    92: "Gamificación",
    93: "Gamificación alumno",
    98: "Libreta de notas",
    99: "Migración de datos",

    100: "Simulador de clases", //PERFIL ESTUDIANTE
    101: "Gestión de simuladores", // PERFIL DOCENTE
    102: "Simulador del estudiante", // PERFIL PADRE
    131: "Buzón de mensajería",
    132: "Pantalla de inicio",
    133: "Configuración de pantalla de inicio",

    141: "Configuración de admisión",
    142: "Relación de postulantes",
    // 143: "Banco de Preguntas",
    143: "Gestión de preguntas", //MANAGER
    153: "Situación del estudiante",
    162: "Horario manual",
    163: "Carga docente",
  },

  action: {
    delete: "Eliminar",
  },
};
